import { remotionPlayerStateStore } from '@/Pages/Clip/ClipPlayer/ClipNewTimeline/store/remotionPlayerState';
import { getSegmentAtCurrentFrame } from '@/Pages/Clip/ClipPlayer/ClipNewTimeline/timeUtils';
import { Clip } from '@/player-config/src/types/clip-types';
import { SegmentType } from '@/player-config/src/types/Segment/Type';

export const getLayoutChangeAtCurrentFrame = (clip: Clip) => {
  const currentClipMetadata = clip.asset_metadata;
  const playerConfig = currentClipMetadata.player_config;

  if (playerConfig) {
    const currentSegment = getSegmentAtCurrentFrame(remotionPlayerStateStore.getSnapshot()?.currentTime || 0, clip);
    if (!currentSegment || currentSegment.type !== SegmentType.COMPOSITE) {
      return;
    }
    const currentSegmentFrame = remotionPlayerStateStore.getSnapshot()?.currentTime || 0 - currentSegment.fromFrame;

    const layoutChanges = currentSegment.layoutChanges;

    return layoutChanges.find(
      layoutChange => layoutChange.fromFrame <= currentSegmentFrame && layoutChange.toFrame > currentSegmentFrame
    );
  }

  return;
};
